<script>
import { get } from "lodash";
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';
import { KenwoodItaly } from '../../modules/kenwood_italy_module.js'

export default {
  mixins: [fandomBasicMixin],
  data: function() {
    return { };
  },
  mounted() {
    Vue.nextTick(() => {
      for (let i = 0; i < this.content.menu.length; i++) {
        const selector = `#navbar-item-${i}`;
        KenwoodItaly.trackLinkVisited(selector, "Interaction", "Menu Click", $(selector).html());
      }
    });
  },
  methods: {
    isUserRegistered: Fandom.isUserRegistered,
    getTarget: Fandom.getTarget,
    getBackgroundUrl: Fandom.getBackgroundUrl,
    rightBoxItems(menuItem) {
      let  items = [];
      for (let i = 0; i < menuItem.menu.length/2; i++) {
        items[i] = [];
      }
      menuItem.menu.forEach((section, index) => {
        const pos = Math.floor(index/2);
        items[pos].push(section);
      });
      return items;
    },
    linkUrl(item) {
      const url = get(item, ["url", "url"], false);
      return !url || url == "#" ? "javascript:void(0)" : url;
    },
    isItemActive(item) {
      const re = new RegExp(`^(${item.matching_name})$`);
      return re.test(globalState.pageModel.main_content_name);
    },
    getSubItemColClass(item) {
      const n = item.menu.length;
      return `col-${n < 3 ? 12 : n < 4 ? 6 : 4}`;
    },
    getItemColClass(item) {
      const n = item.menu.length;
      return [`col-${n < 3 ? 6 : 8}`, `col-${n < 3 ? 6 : 4}`];
    }
  },
  computed: { },
};
</script>

<template>
  <div class="w-100 d-flex justify-content-center align-items-center" navbar-component>
    <div v-for="(item, index) in content.menu" class="menu-item d-flex justify-content-center align-items-center cursor-pointer text-uppercase position-relative px-4" :class="[`bg-hover-${item.color ? item.color : 'orange'}`, {'active': isItemActive(item)}]">
      <a 
        :href="linkUrl(item)" 
        :target="getTarget(item.url)"
        class="link-black"
        :id="`navbar-item-${index}`"
      >{{item.url.title}}</a>
      <div class="sub-menu position-absolute d-none mx-0" :style="{'max-width': item.max_width || '57rem'}" v-if="item.menu">
        <div class="row mx-0">
          <div :class="getItemColClass(item)[0]" class="p-0">
            <div class="m-3 p-3 row position-relative border-right">
              <div v-for="(couple, index) in rightBoxItems(item)" :class="getSubItemColClass(item)" class="col-4 d-flex flex-column">
                <div v-for="section in couple" class="d-flex flex-column mb-3">
                  <span class="section font-sm" :class="`text-${item.color ? item.color : 'orange'}`">
                    {{section.title}}
                  </span>
                  <div v-for="subItem in section.menu">
                    <a :href="subItem.url.url" :target="getTarget(subItem.url)" class="sub-item font-xs">{{subItem.url.title}}</a>
                  </div>
                </div>
                <div v-if="couple.length == (index) && item.corner_url" class="d-flex flex-column mb-3">
                  <span class="section font-sm corner-url" :class="`text-${item.color ? item.color : 'orange'}`">
                    <a :class="`text-${item.color ? item.color : 'orange'}`" :href="item.corner_url.url" :target="getTarget(item.corner_url)">
                      {{item.corner_url.title}}
                    </a>
                    <i class="far fa-chevron-right ml-1"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div :class="getItemColClass(item)[1]" class="pr-3 pl-0 py-3 d-flex flex-column" v-if="item.right_launch_box">
            <div class="section font-sm my-3" v-if="item.right_launch_box.title" :class="`text-${item.color ? item.color : 'orange'}`">
              {{item.right_launch_box.title}}
            </div>
            <div class="url-lg text-capitalize" v-if="item.right_launch_box.url_1">
              <a class="font-xl link-black" :href="item.right_launch_box.url_1.url" :target="getTarget(item.right_launch_box.url_1)">
                {{item.right_launch_box.url_1.title}}
              </a>
            </div>
            <div class="url-lg text-capitalize" v-if="item.right_launch_box.url_2">
              <a class="font-xl link-black" :href="item.right_launch_box.url_2.url" :target="getTarget(item.right_launch_box.url_2)">
                {{item.right_launch_box.url_2.title}}
              </a>
            </div>
            <div 
              class="bg-cover-center w-100 flex-grow-1 mt-3" 
              v-if="item.right_launch_box.image" 
              :style="{ 'background-image': getBackgroundUrl(item.right_launch_box.image.url) }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">

[navbar-component] { 
  height: $navbar-height;

  .menu-item {
    z-index: $zindex-menu-item;
    transition: all $animation-time-fast;
    height: $top-level-item-height;

    & > a {
      text-decoration: none;
    }

    &:hover,
    &.active {
      & > a {
        color: $white !important;
      }
    }

    &:hover .sub-menu {
      display: block !important;
    }

    & > a {
      height: 1.2rem;
    }
  }

  .sub-menu {
    top: $top-level-item-height;
    background-color: $white;
    cursor: default;
    color: $dark;
    z-index: 1;
    width: 100vw;

    a.sub-item {
      color: $dark;
      text-transform: capitalize;
    }

    .url-lg {
      font-family: $bressay-font; // TODO: move into font variable;
    }

    .img-box > img {
      width: 100%;
      height: auto;
    }
  }

  .corner-url {
    
    a {
      text-transform: uppercase;
      text-decoration: underline;
      font-size: 0.875rem;
    }

    .far.fa-chevron-right {
      font-size: 0.875rem; /* 14/16 */
    }

  }

  @media only screen and (max-width: 1185px) {
    
    & {
      position: relative;
    }

    .menu-item {
      position: static !important;
    }

    .sub-menu {
      left: 0;
      top: calc(((#{$navbar-height} - #{$top-level-item-height}) / 2) + #{$top-level-item-height});
      max-width: 100vw;
    }
  }
  
}
</style>

